import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { AdminContentSeriesResponse, ListAdminContentSeriesParams } from './types';

export type ListAdminContentSeriesResponse = PaginatedListResponse<AdminContentSeriesResponse> & { total?: number };

export async function listAdminContentSeries(params: ListAdminContentSeriesParams = {}) {
  const url = '/web/studio/admin/content-series';

  const queryParams: Record<string, string | number | boolean> = {};

  if (params.search) queryParams.search = params.search;
  if (params.artistId) queryParams.artist_id = params.artistId;
  if (params.premiumType) queryParams.premium_type = params.premiumType;
  if (params.isFeatured !== undefined) queryParams.is_featured = params.isFeatured;
  if (params.parentsOnly) queryParams.parents_only = true;
  if (params.status) queryParams.status = params.status;
  if (params.sortColumn) queryParams.sort_column = params.sortColumn;
  if (params.sortDirection) queryParams.sort_direction = params.sortDirection;
  if (params.limit !== undefined) queryParams.limit = params.limit;
  if (params.offset !== undefined) queryParams.offset = params.offset;

  const response = await api.executeGetRequest<ListAdminContentSeriesResponse>(url, queryParams);

  return response;
}
